import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-08e8d3c0"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "body"
};
const _hoisted_2 = {
  key: 0,
  style: {
    "float": "right"
  }
};
const _hoisted_3 = {
  key: 0,
  class: "col_bblue"
};
const _hoisted_4 = {
  style: {
    "color": "#7e7f86",
    "margin-left": "10px"
  }
};
const _hoisted_5 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "flex-wrap": "wrap"
  }
};
const _hoisted_6 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_7 = {
  key: 0,
  style: {
    "display": "flex"
  }
};
const _hoisted_8 = {
  style: {
    "width": "130px",
    "height": "130px",
    "display": "flex",
    "flex-direction": "column",
    "align-items": "center",
    "margin-bottom": "15px"
  }
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  style: {
    "width": "120px",
    "margin-top": "6px",
    "height": "30px",
    "text-align": "center",
    "line-height": "28px",
    "color": "rgb(126,127,134)",
    "overflow": "hidden",
    "text-overflow": "ellipsis",
    "white-space": "nowrap"
  }
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_17 = {
  key: 1
};
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
};
const _hoisted_20 = {
  key: 0
};
const _hoisted_21 = {
  key: 0,
  style: {
    "margin-top": "19px"
  }
};

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "120px",
    "height": "28px",
    "line-height": "28px",
    "text-align": "center",
    "color": "rgb(126,127,134)"
  }
}, " 用户未上传 ", -1));

const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = {
  key: 1,
  style: {
    "margin-top": "16px"
  }
};

const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "120px",
    "height": "28px",
    "line-height": "28px",
    "text-align": "center",
    "color": "rgb(126,127,134)"
  }
}, " (用户上传) ", -1));

const _hoisted_26 = [_hoisted_25];
const _hoisted_27 = {
  style: {
    "width": "90%",
    "margin": "0 auto"
  }
};
const _hoisted_28 = {
  key: 0,
  style: {
    "margin": "20px 0 0 10px",
    "color": "#D9001B",
    "display": "flex",
    "width": "100%"
  }
};

const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 补充备注: ", -1));

const _hoisted_30 = {
  style: {
    "margin-left": "5%",
    "width": "80%",
    "word-wrap": "break-word"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");

  const _component_el_tooltip = _resolveComponent("el-tooltip");

  const _component_el_form = _resolveComponent("el-form");

  const _component_el_upload = _resolveComponent("el-upload");

  const _component_el_image_viewer = _resolveComponent("el-image-viewer");

  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [$props.dpt.status && $props.dpt.status != '1' && $props.dpt.status != '5' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$props.dpt.status == '2' ? (_openBlock(), _createElementBlock("div", _hoisted_3, " 审核中 ")) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass($options.getClassByStatus($data.dataInfo.answerVo.checkStatus))
  }, _toDisplayString($data.dataInfo.answerVo.checkStatusName), 3))])) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass($data.dataInfo.isEssential ? 'star' : ''),
    style: {
      "font-weight": "bold",
      "margin-bottom": "20px",
      "font-size": "14px"
    }
  }, [_createTextVNode(_toDisplayString($props.listIndex) + ".上传示例" + _toDisplayString($props.isVideo ? '视频' : '图片'), 1), _createElementVNode("span", _hoisted_4, "请根据示例上传" + _toDisplayString($props.isVideo ? '视频' : '图片'), 1)], 2), _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dataInfo.itemList, (item, index) => {
    return _openBlock(), _createElementBlock("div", _hoisted_6, [item.url ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$props.isVideo ? (_openBlock(), _createElementBlock("div", _hoisted_9, [item.url ? (_openBlock(), _createElementBlock("video", {
      key: 0,
      src: $options.replacePath(item.url),
      class: "avatar",
      autoplay: "",
      controls: "",
      style: {}
    }, null, 8, _hoisted_10)) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [item.url ? (_openBlock(), _createBlock(_component_el_image, {
      key: 0,
      class: "avatar",
      src: $options.replacePath(item.url),
      "preview-src-list": $data.imgArrayE,
      style: {},
      fit: "cover"
    }, null, 8, ["src", "preview-src-list"])) : _createCommentVNode("", true)])), _createVNode(_component_el_form, {
      style: {
        "margin-top": "13px"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tooltip, {
        class: "item",
        effect: "dark",
        content: item.name,
        placement: "top"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1)]),
        _: 2
      }, 1032, ["content"])]),
      _: 2
    }, 1024)]), _createElementVNode("div", {
      style: {
        "width": "130px",
        "height": "130px",
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
        "margin-bottom": "15px"
      },
      onClick: $event => $options.clickShowImage(index)
    }, [_createVNode(_component_el_upload, {
      class: "avatar-uploader",
      action: "/javaplus/user/file/upload",
      "show-file-list": false,
      disabled: ""
    }, {
      default: _withCtx(() => [$props.isVideo ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_ctx.itemListCopy[index].url ? (_openBlock(), _createElementBlock("video", {
        key: 0,
        src: _ctx.itemListCopy[index].url,
        class: "avatar",
        autoplay: "",
        controls: ""
      }, null, 8, _hoisted_15)) : (_openBlock(), _createElementBlock("i", _hoisted_16))])) : (_openBlock(), _createElementBlock("div", _hoisted_17, [_ctx.itemListCopy[index].url ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: _ctx.itemListCopy[index].url,
        class: "avatar",
        style: {
          "object-fit": "contain"
        }
      }, null, 8, _hoisted_18)) : (_openBlock(), _createElementBlock("i", _hoisted_19))]))]),
      _: 2
    }, 1024), $props.dpt.status ? (_openBlock(), _createElementBlock("div", _hoisted_20, [!_ctx.itemListCopy[index].url ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_23)) : (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))])) : _createCommentVNode("", true)], 8, _hoisted_13)])) : _createCommentVNode("", true)]);
  }), 256))])]), _createElementVNode("div", _hoisted_27, [$data.dataInfo.answerVo?.checkStatus === '1' && $props.dpt.status != '2' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString($data.dataInfo.answerVo.checkRemark), 1)])) : _createCommentVNode("", true)]), $data.imgViewerShow && $props.dpt.status != "1" && $data.dataInfo.questionType == "32" ? (_openBlock(), _createBlock(_component_el_image_viewer, {
    key: 0,
    onClose: _cache[0] || (_cache[0] = $event => $data.imgViewerShow = false),
    infinite: false,
    "url-list": $data.imgArray,
    "initial-index": $data.imgIndex
  }, null, 8, ["url-list", "initial-index"])) : _createCommentVNode("", true)]);
}